export function pinReducer(
  state: {
    anchorX: number
    anchorY: number
    positionX: number
    positionY: number
  },
  action: { name: string; value: any }
): {
  anchorX: number
  anchorY: number
  positionX: number
  positionY: number
} {
  if (action.name === 'all') {
    return { ...action.value }
  }
  return { ...state, [action.name]: action.value }
}
